import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function getViewClientData(client_id) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'get_clientdata/' + client_id )
          .then((res) => {
            console.warn('InspectorData123', res.data)
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
  }